import React, { useEffect, useRef } from 'react'
import techbg1 from '../../Image/techbg1.png'
import techbg2 from '../../Image/techbg2.png'
import techbg3 from '../../Image/techbg3.png'
import techbg4 from '../../Image/techbg4.png'
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { useLocation } from 'react-router-dom'
gsap?.registerPlugin(MotionPathPlugin);
const images = Array?.from({ length: 26 }, (_, i) => require(`../../Image/tech${i + 1}.png`));
const Technologies = () => {
    const containerRef = useRef(null);
    const imageRefs = useRef([]);
    const path = useLocation();
    
    useEffect(() => {
        const initializePositions = () => {
            const pathId = window.innerWidth >= 1024
                ? "#figureEightPathDesktop"
                : "#figureEightPathMobile";

            const pathElement = document.querySelector(pathId);
            if (!pathElement) {
                // Retry after a short delay if path not found
                setTimeout(initializePositions, 100);
                return;
            }

            // Set initial static positions along the actual path
            imageRefs?.current?.forEach((el, i) => {
                if (!el) return;

                const start = (i / images.length);

                // Set position along path without animation
                gsap.set(el, {
                    motionPath: {
                        path: pathElement,
                        align: pathElement,
                        alignOrigin: [0, 0],
                        start: start,
                    },
                });
            });
        };

        // Start initialization after a small delay to ensure DOM is ready
        setTimeout(initializePositions, 50);
    }, []); // Run only once when component mounts

    // Start animation only when on homepage
    useEffect(() => {
        if (path?.pathname === '/') {
            const startAnimation = () => {
                const pathId = window.innerWidth >= 1024
                    ? "#figureEightPathDesktop"
                    : "#figureEightPathMobile";

                const pathElement = document.querySelector(pathId);
                if (!pathElement) {
                    setTimeout(startAnimation, 100);
                    return;
                }

                imageRefs?.current?.forEach((el, i) => {
                    if (!el) return;

                    const delay = (i / images.length) * 22;

                    gsap.to(el, {
                        duration: 22,
                        repeat: -1,
                        ease: 'linear',
                        delay,
                        motionPath: {
                            path: pathElement,
                            align: pathElement,
                            alignOrigin: [0, 0],
                            autoRotate: false,
                        },
                    });
                });
            };

            const timer = setTimeout(startAnimation, 600); // Wait a bit longer for initial positioning
            return () => clearTimeout(timer);
        }
    }, [path?.pathname]);   

    return (
        <div className='overflow-hidden relative py-5'>
            <div className='relative  '>
                <div className='relative z-[1] container py-8 '>
                    <div className='text-center  m-auto '>
                        <div className='flex justify-center flex-wrap'>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-[#141414]  leading-[40px] 2xl:leading-[60px]'>TECHNOLOGIES</h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-theme_dark  leading-[40px] 2xl:leading-[60px] ps-2'>WE WORK WITH</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div
                ref={containerRef}
                className="
                z-[1]
                    relative xl:w-full
                    h-[500px] lg:h-[700px] sm:h-[800px]
                    bg-transparent
                    top-[-40px] sm:top-[-60px] md:top-[-100px]
                    left-[-5px] sm:left-[-20px] lg:left-[-100px] xl:left-[-50px]
                    lg:w-[110%] w-full
                    overflow-hidden
                "
            >
                <svg
                    viewBox="0 0 800 700"
                    className="hidden lg:block xl:w-full w-[80%] m-auto h-full"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path
                        id="figureEightPathDesktop"
                        d="
                            M 400,350
                            C 400,50  -50,50  -50,350 
                            C -50,650 400,650 400,350 
                            C 400,50 850,50 850,350 
                            C 850,650 400,650 400,350 Z"
                        fill="none"
                        stroke="none"
                    />
                </svg>

                {/* Image in center of left loop */}
                <div className='sp_tech'>
                <img
                    src={techbg1}
                    alt="Left Center"
                    className="sptech11"
                />

                {/* Right loop image (at approx 625, 350) */}
                <img
                    src={techbg2}
                    alt="Right Center"
                    className="sptech21"
                />
                </div>
                <svg
                    viewBox="0 0 1000 1600"
                    className="block lg:hidden w-[100%] h-[500px] lg:h-[900px] sm:h-[800px] m-auto"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path
                        id="figureEightPathMobile"
                        d="
                        M 500,800
                        C 100,800 100,200 500,200
                        C 900,200 900,800 500,800
                        C 100,800 100,1400 500,1400
                        C 900,1400 900,800 500,800 Z"
                        fill="none"
                        stroke="none"
                        strokeWidth="2"
                    />

                </svg>

                {images?.map((src, i) => (
                    <div
                        key={i}
                        ref={(el) => (imageRefs.current[i] = el)}
                        className="
                            w-[40px] h-[40px] sm:w-[60px] sm:h-[60px] lg:w-[80px] lg:h-[80px]
                            bg-theme_light rounded-full flex justify-center items-center object-cover
                            p-1 sm:p-2 lg:p-4 border-[1px] border-theme_dark
                        "
                    >
                        <img src={src} alt={`tech-${i}`} className="w-[80%] object-cover" />
                    </div>
                ))}
            </div>
            <img src={techbg3} alt='techbg3' className='absolute top-0 left-0 z-[0]  w-auto hidden lg:block w-[50%]'></img>
            <img src={techbg4} alt='techbg4' className='absolute bottom-0 right-0  z-[0] w-[50%] sm:w-auto'></img>
        </div>
    )
}
export default Technologies
